import { useEffect, useState } from 'react';
import {
  getImpersonationSnapshot,
  subscribeImpersonation,
} from '../Services/impersonationSession';

export function useImpersonation() {
  const [snapshot, setSnapshot] = useState(getImpersonationSnapshot);
  useEffect(() => subscribeImpersonation(setSnapshot), []);
  return snapshot;
}
